import React from "react"
import "slick-carousel/slick/slick.css"
import Video from "../../molecules/video/video"
import LandingText from "../../molecules/landingtext/landingtext"
import HeroImage from "../../molecules/heroImage/heroImage"
import "./designSection.scss"
import StopMotion from "../stopMotion/stopMotion"
import useIsMobile from "../../../hooks/useIsMobile"
import Overlay from "./overlay"

const Slide = ({ element, inView, slug, mobile, prev, next, pageContext }) => {
  const isMobile = useIsMobile()
  const mobileClass = isMobile || mobile ? "mobile" : ""

  const isDescriptionVisible = !isMobile && inView
  if (element) {
    return (
      <div className={`slide--inner ${mobileClass}`}>
        <div className={`ahoy-slide ${mobileClass}`} 
            style={element.type === "WpDesign_Designflexfields_Slides_Textblock" && isMobile ? { height: 'auto', minHeight: '56.25vw' } : {}}>
          {
            {
              WpDesign_Designflexfields_Slides_Image: (
                <>
                  <HeroImage
                    image={element.image?.localFile?.childImageSharp}
                    className={mobileClass}
                    format={element.format}
                  />
                  { element.textoverlay && <LandingText content={element.textoverlay} /> }
                </>
              ),
              WpDesign_Designflexfields_Slides_VideoBlock: (
                <>
                  <Video
                    iframe={element.video}
                    inView={inView}
                    format={element.format}
                  />
                  {element.textoverlay && <LandingText content={element.textoverlay} /> }
                </>
              ),
              WpDesign_Designflexfields_Slides_Textblock: <LandingText content={element.text} textBackgroundColor={element.textBackgroundColor}  />,
              WpDesign_Designflexfields_Slides_StopMotion: (
                <StopMotion
                  frames={element.frames}
                  speed={element.speed}
                  slug={slug}
                  format={element.format}
                />
              ),
            }[element.type]
          }
          <div
            className={
              isDescriptionVisible
                ? "side-description active"
                : "side-description"
            }
          >
            <div className="upper">
              <p
                dangerouslySetInnerHTML={{
                  __html: element.sideDescription.upper,
                }}
              />
            </div>
            {element.sideDescription.upper && element.sideDescription.lower && (<hr />)}
            <div className="lower">
              <p
                dangerouslySetInnerHTML={{
                  __html: element.sideDescription.lower,
                }}
              />
            </div>
          </div>
          {!pageContext.scroller && <Overlay prev={prev} next={next} pageContext={pageContext} />}
        </div>
      </div>
    )
  } else return <div />
}

export default Slide

// export const query = graphql`

//   fragment SlideFormat on WpDesign {
//     format {
//       boundaries
//       shadow
//       size
//       ratio {
//         width
//         height
//       }
//     }
//   }

//   fragment SideDescription on WpDesign {
//     sideDescription {
//       lower
//       upper
//     }
//   }
// `;